import type { FaireProductEntity } from "../../entity_types/product";

export const p_827myhbz4e: FaireProductEntity = {
  token: "p_827myhbz4e",
  type: "product",
  name: "Art Deco Chain Bracelet With Baguette Stones",
  brandToken: "b_7sddd34i",
  brandName: "Tai Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/9e7a536e4cd640f9633f0a1937b185bceb264ef28e653f3f876b38017179e79a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1bfd212d231cda3139fe8758083aeffdcd4c4287397cc790ede349850205abb.webp",
  ],
  priceDollars: 62.36,
  description:
    'Channel vintage glam with our Art Deco Baguette Bracelet – a bold and brilliant accessory that’s equal parts chic and powerful.\n\nMaterial: Stainless Steel, Cubic Zirconia\nDimension: Length: 6" +2" extender = 8", Width: 6mm\nClosure: Lobster Clasp \nSKU: ZTB-05 (G)',
  tags: [],
  msrpDollars: 124.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:52.319Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
